"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = {
  name: 'TableClientsList',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actionOpen: {
      type: Function,
      default: function _default() {}
    },
    delCoop: {
      type: Function,
      default: function _default() {}
    }
  }
};
exports.default = _default2;